/*----------------------------------------------------------------
  Canonical Arrow → plain-JS converter.
  Works with every object DuckDB-WASM can return:
    • Table           (.toArray())
    • RecordBatch     (.toArray())
    • RecordBatchReader (.readAll / iterator)
----------------------------------------------------------------*/

export function arrowTableToObjects(result: any): any[] {
  if (!result) return [];

  // Arrow Table / RecordBatch have .toArray()
  if (typeof result.toArray === "function") {
    return result
      .toArray()
      .map((row: any) =>
        typeof row?.toJSON === "function" ? row.toJSON() : row
      );
  }

  // RecordBatchReader (DuckDB uses this for large results)
  if (typeof result.readAll === "function" || Symbol.iterator in result) {
    const rows: any[] = [];
    for (const batch of result) {
      if (typeof batch?.toArray === "function") {
        rows.push(
          ...batch
            .toArray()
            .map((row: any) =>
              typeof row?.toJSON === "function" ? row.toJSON() : row
            )
        );
      }
    }
    return rows;
  }

  // Already an array? just return it.
  return Array.isArray(result) ? result : [];
}
